// XPROJECT public URLs. Override API endpoints for local development.
export const PRODUCT_NAME = 'XPROJECT';
export const WEBSITE_URL = 'https://xproject.cheink.com';
export const CLIENT_URL = WEBSITE_URL + '/client';
export const CONSOLE_URL = WEBSITE_URL + '/console';
export const API_BASE_URL = (process.env.VUE_APP_API_BASE_URL || '/api/client').replace(/\/$/, '');
